import { hashMD5 } from "../../../components/Auth/AuthUtils";
import { dataAtualFormatada } from "../../../util/FuncoesComuns";
import IUnidadeUnitizadoresItensGeralAlerta from "../interfaces/IUnidadeUnitizadoresItensGeralAlerta";

const downloadBase64PDF = (nomeDoc: string,pdfDocumento: any) => {
    let byte = Uint8Array.from(atob(pdfDocumento), c => c.charCodeAt(0));
    const url = window.URL.createObjectURL(new Blob([byte]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', nomeDoc);
    document.body.appendChild(link);
    link.click();
    //Step 3: Clean up the temporary URL
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
}

const gerarHashMd5ParaPDF = (codSroDestino: string, listaItens: IUnidadeUnitizadoresItensGeralAlerta[] = []) => {
    const dataIniAno = dataAtualFormatada('ano', '-');
    let valor = listaItens && Array.isArray(listaItens) && listaItens.length > 0 && listaItens[0].codSroOrigem ? listaItens[0].codSroOrigem.concat(listaItens.length.toString(),codSroDestino,dataIniAno) : '';
    listaItens.forEach(item => {
        valor.concat(item?.numUnitizador, item?.objeto);
    })

    return hashMD5(valor);
}

export {downloadBase64PDF, gerarHashMd5ParaPDF};
